import { render, staticRenderFns } from "./ParagraphSettings.vue?vue&type=template&id=b9a9caec&scoped=true"
import script from "./ParagraphSettings.vue?vue&type=script&lang=js"
export * from "./ParagraphSettings.vue?vue&type=script&lang=js"
import style0 from "./ParagraphSettings.vue?vue&type=style&index=0&id=b9a9caec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a9caec",
  null
  
)

export default component.exports